/**
 * Interface to define what properties/methods are required for an Overlay source.
 */
export class OverlaySource {
  constructor(props) {
    this.ref = props.ref;
    this.onCloseRequest = props.onCloseRequest;
    this.getIsPreventClose = props.getIsPreventClose;
    this.getShouldBlockInteractOutsideOverride = props.getShouldBlockInteractOutside;
  }

  /**
   * Whether an interaction that closes this overlay should be swallowed. A non-blocking overlay
   * (e.g. a tooltip) still closes, but lets the pointer event reach its target.
   */
  getShouldBlockInteractOutside() {
    return this.getShouldBlockInteractOutsideOverride?.() ?? true;
  }
}
